import { isPlatform } from "@ionic/core";

export const isAppRunningOnMobile = (): boolean => {
  const isMobileApp = isPlatform("cordova");
  const isRunningOnMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const isMobile = isMobileApp || isRunningOnMobile;
  return isMobile;
};
